import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import ScanVerfiryPrint from 'components/Sales/ScanVerifyPrint';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <ScanVerfiryPrint />
      </SiteContent>
    </ContentLayout>
  );
};
